export enum ContentTypes {
  pdf = "application/pdf",
  html = "text/html",
  images = "image/*",
  csv = 'text/csv',
  json = 'application/json',
}
